import Axios from 'axios';

import { User } from '../models';

export const upsertHubspotContact = (input: Required<Pick<User, 'email' | 'jobTitle' | 'testingSolutions' | 'firstName' | 'lastName'>>) => (
  Axios.post('/v1/webhook/website/contact', input)
);
